import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';

/**
 * Hook that returns the current width of a div element, while also adding a listener to window resize events
 */
export const useResize = (): { width: number; height: number; elementRef: React.RefObject<HTMLDivElement> } => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const handleResize = throttle((): void => {
      setWidth(elementRef.current?.offsetWidth ?? width);
      setHeight(elementRef.current?.offsetHeight ?? height);
    }, 200);

    window.addEventListener('resize', handleResize);

    setWidth(elementRef.current?.offsetWidth ?? width);
    setHeight(elementRef.current?.offsetHeight ?? height);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef.current]);

  return { width, height, elementRef };
};
